<script lang="ts" setup>
import { computed, Ref, ref } from "vue";
import { HIGH_TAB, useTask } from "@/stores/task";
import Gallery, {
  GalleryInstance,
} from "@/components/mobile/media/Gallery.vue";
import { watch } from "vue";
import { onMounted } from "vue";
import { Tab, Tabs } from "vant";
import { useI18n } from "vue-i18n";
// 1. 常量
// 2. Props & Emit & Expose

const { t } = useI18n();

export interface GenMedia extends Media {
  textImage?: Omit<TextImage, "media">;
  storyVideo?: Omit<StoryVideo, "media">;
  entityType?: string;
  entity?: TextImage | StoryVideo;
}

export interface GenGalleryInstance {
  clear: (clearFilter?: boolean) => void;
  selectedMediaList: Ref<GenMedia[]>;
}

const props = withDefaults(
  defineProps<{
    filter?: 1 | 2; // 1-图片；2-视频
    selectable?: boolean;
    enableUpload?: boolean;
    maxSelectCount?: number;
  }>(),
  {
    selectable: false,
    enableUpload: false,
    maxSelectCount: 1,
  }
);
// 3. 内部状态
const tab = ref(1);
const taskStore = useTask();
const galleryRef = ref<GalleryInstance | null>(null);
const allMediaList = ref<GenMedia[]>();

const onTabChange = (tab: number) => {
  taskStore.selectGalleryType = (tab + 1) as 1 | 2;
  galleryRef.value?.resetScrollLoadingState();
};

const initData = () => {
  allMediaList.value = taskStore.galleryList[taskStore.selectGalleryType]
    .map((item) => {
      const _m = taskStore.getTask(item)!;
      const m: GenMedia = {
        ...(_m.entity.media as Media),
      };
      if (_m.entityType === "App\\Models\\TextImage") {
        if (_m.entity.isNsfw && !_m.entity.isPaid) return null;

        m.textImage = _m.entity as TextImage;
      }
      if (_m.entityType === "App\\Models\\StoryVideo") {
        m.storyVideo = _m.entity as StoryVideo;
      }
      taskStore.galleryMap.set(m.id!, m);
      return m;
    })
    .filter((item) => item !== null) as GenMedia[];
};

watch(
  [() => taskStore.galleryList, () => taskStore.selectGalleryType],
  () => {
    initData();
  },
  {
    deep: true,
  }
);

defineExpose<GenGalleryInstance>({
  clear: (clearFilter?: boolean) => {
    galleryRef.value!.clear(clearFilter);
  }, // method: 刷新gallery列表
  selectedMediaList: computed(
    () => galleryRef.value?.selectedMediaList as GenMedia[]
  ), // computed: 已选中的媒体列表
});

onMounted(() => {
  galleryRef.value?.clear();
  taskStore.selectGalleryType = HIGH_TAB;
  initData();
});
</script>
<template>
  <div class="grid grid-rows-[auto_1fr] h-full overflow-hidden">
    <Tabs v-model:active="tab" swipeable @change="onTabChange">
      <Tab
        v-for="i in 2"
        :key="i"
        :show-zero-badge="false"
        :title="t(`task.type.${i}`)"
      >
      </Tab>
    </Tabs>
    <gallery
      ref="galleryRef"
      :media-list="allMediaList"
      :on-pull-load="() => taskStore.fetchGallery(true)"
      :on-scroll-load="() => taskStore.fetchGallery(false)"
      v-bind="props"
    />
  </div>
</template>
